export default __webpack_public_path__ + "static/media/dates-desktop.5e7554e7.svg";